import { useEffect } from "react";

const DynamicTitleSetter = () => {
  useEffect(() => {
    const url = window.location.href;

    // if (url.includes("/login")) {
    //   document.title = "Admission Portal - Login";
    // } else 
     if (url.includes("/digital-enterprise-management")) {
      document.title = "Admission Portal - MBA in Digital Enterprise Management";
    } else if (url.includes("/global-supply-chain-management")) {
      document.title = "Admission Portal - MBA in Global Supply Chain Management";
    } else {
      document.title = "Admission Portal";
    }
  }, []);

  return null; 
};

export default DynamicTitleSetter;
